import { render } from "./BetaBadge.vue?vue&type=template&id=69f48282&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"

import "./BetaBadge.vue?vue&type=style&index=0&id=69f48282&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-69f48282"

export default script